export default __webpack_public_path__ + "static/media/reconnect.3ace16bb.png";